import Transform from './Base';

export default class JerseysTransform extends Transform {
  /**
   * Method used to transform fetched jerseys.
   *
   * @param jersey The fetched jersey.
   *
   * @returns {Object} The transformed jersey.
   */
  static fetch(jersey) {
    return {
      ...jersey,
      height: jersey?.thumbnail_width || 150,
      image: `data:image/jpeg;base64,${jersey.image}`,
      width: jersey?.thumbnail_height || 150,
    };
  }

  static fetchScore(jersey) {
    if (Object.keys(jersey).length === 0) {
      return [];
    }

    const result = [];
    for (let key in jersey) {
      const { percentage, score } = jersey[key];
      result.push({
        number: parseInt(key),
        percentage: (percentage * 100).toFixed(1),
        score: (score * 100).toFixed(2),
      })
    }
    return result.sort((a, b) => b.percentage - a.percentage);
  }
}
